import BottomTab from "./bottomTab";
import { Footer } from "./footer";
import Header from "./header";

export default function Layout({
  className,
  showMobileHeader = true,
  showBottomTab = true,
  children,
}) {
  return (
    <div className={`w-full min-h-screen bg-foreground-700 ${className}`}>
      <Header showMobileHeader={showMobileHeader} />
      <div className="flex flex-col">{children}</div>
      <div className="hidden lg:block">
        <Footer />
      </div>
      {showBottomTab && (
        <div className="block lg:hidden">
          <BottomTab />
        </div>
      )}
    </div>
  );
}
